import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { BadgeCheck } from 'lucide-react';
import { ReactComponent as VerificationPendingIcon } from '@assets/icons/verification-pending.svg';
import { UserName, UserNameWithStatusRoot } from './UserNameWithStatus.styles';

type Props = {
  name?: string;
  role?: string;
  signatoryStatus?: string | 'verified' | 'pending' | null;
  signatory?: string | null;
};

export default function UserNameWithStatus({ name, role, signatoryStatus, signatory }: Props) {
  const theme = useTheme();

  return (
    <UserNameWithStatusRoot>
      <UserName>{name}</UserName>
      {signatoryStatus === 'verified' ? (
        <BadgeCheck size={14} color={theme.palette.primary.main} />
      ) : (
        !!signatory && <VerificationPendingIcon />
      )}
      {role === 'guest' && <Chip size='small' color='warning' label='Guest' />}
    </UserNameWithStatusRoot>
  );
}
